import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "background-color": "#f7f7f7",
    "padding-bottom": "10px"
  }
};
const _hoisted_2 = {
  class: "news-content"
};
const _hoisted_3 = {
  class: "nav-link"
};
const _hoisted_4 = {
  style: {
    "padding": "0 10px",
    "margin-bottom": "10px"
  }
};
import FriendLink from "@/views/components/friendLink.vue";
import { breadCrumb } from '@/utils/dic';
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import { getProvincesDetail } from '@/api/home';
import { getCurrentInstance, ref } from 'vue';
import { tableProps } from "./newsListConfig";
export default {
  __name: 'newsList',
  setup(__props) {
    const provinceInfo = JSON.parse(sessionStorage.getItem('provinceInfo')) || {};
    const {
      proxy
    } = getCurrentInstance();
    let queryParams = ref({});
    let businessSysRecords = ref([]);
    let operationLinks = ref([]);
    let friendlyLinks = ref([]);
    const route = useRoute();
    let fcKey = ref('');
    let breadName = ref('');
    getProvinceEntranceInfo();
    watch(() => route.query.type, val => {
      val ? breadName.value = breadCrumb[val]?.name : breadName.value = '';
      fcKey.value = breadCrumb[val].functionKey;
      proxy.$nextTick(() => {
        handleSearch(val);
      });
    }, {
      immediate: true
    });
    function emitAlink(data) {
      if (data.key === 'title') {
        const type = route.query.type;
        openInNewTab('/article', {
          id: data.rowData.id,
          type
        });
      }
    }
    const router = useRouter();
    function openInNewTab(path, query) {
      const url = router.resolve({
        path,
        query
      }).href;
      window.open(url, "_blank");
    }
    function handleSearch(code) {
      proxy.$refs.hTable.getList({
        contentTypeCode: code
      });
    }
    function getProvinceEntranceInfo() {
      if (!provinceInfo.linkCode) {
        return;
      }
      getProvincesDetail({
        linkCode: provinceInfo.linkCode
      }).then(res => {
        if (res.success) {
          businessSysRecords.value = res.data.businessSysRecords;
          operationLinks.value = res.data.operationLinks;
          friendlyLinks.value = res.data.friendlyLinks;
        } else {
          proxy.$message.error(res.message);
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_hTable = _resolveComponent("hTable");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(Header), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createTextVNode("当前位置： ")), _cache[1] || (_cache[1] = _createElementVNode("a", {
        href: "/"
      }, "首页", -1)), _createTextVNode(" > " + _toDisplayString(_unref(breadName)), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_hTable, {
        ref: "hTable",
        tableProps: _unref(tableProps),
        queryParams: _unref(queryParams),
        functionKey: _unref(fcKey),
        onAlink: emitAlink
      }, null, 8, ["tableProps", "queryParams", "functionKey"])])])]), _createVNode(Footer)], 64);
    };
  }
};